export default "__VITE_ASSET__C8CR1xD$__"